import { Menu } from "antd";
import styled from "styled-components";

export const DropdownMenuItem = styled(Menu.Item)`
  font-size: ${(props) => props.theme.text.sizes.sbHeader};
`;
